(function () {
  if (window.__diamauraVideoAutoplayRecoveryLoaded) {
    return;
  }

  window.__diamauraVideoAutoplayRecoveryLoaded = true;

  var rootSelector = '[data-da-autoplay-video-root]';
  var videoSelector = '[data-da-autoplay-video]';
  var maxRetries = 6;
  var retryBaseDelay = 700;
  var watchdogDuration = 30000;
  var watchdogInterval = 2000;
  var viewportLead = 1.25;
  var states = new WeakMap();
  var watchdogTimer = 0;
  var watchdogStartedAt = 0;
  var scrollTimer = 0;

  function getState(video) {
    var state = states.get(video);

    if (!state) {
      state = {
        timer: 0,
        retries: 0,
        bound: false,
        posterTimerOne: 0,
        posterTimerTwo: 0
      };
      states.set(video, state);
    }

    return state;
  }

  function hasActiveSource(video) {
    var sources = Array.prototype.slice.call(video.querySelectorAll('source'));

    if (!sources.length) {
      return Boolean(video.currentSrc || video.src || video.getAttribute('data-da-autoplay-video-src'));
    }

    return sources.some(function (source) {
      return (!source.media || window.matchMedia(source.media).matches) && (source.src || source.getAttribute('data-da-autoplay-video-src'));
    });
  }

  function hydrateVideoSources(video) {
    var deferredSrc = video.getAttribute('data-da-autoplay-video-src');
    var sources = Array.prototype.slice.call(video.querySelectorAll('source'));

    if (deferredSrc && !video.getAttribute('src')) {
      video.setAttribute('src', deferredSrc);
      video.removeAttribute('data-da-autoplay-video-src');
    }

    sources.forEach(function (source) {
      var sourceSrc = source.getAttribute('data-da-autoplay-video-src');

      if (sourceSrc && !source.getAttribute('src')) {
        source.setAttribute('src', sourceSrc);
        source.removeAttribute('data-da-autoplay-video-src');
      }
    });
  }

  function isActiveVideo(video) {
    var root = video.closest(rootSelector);

    return (
      root &&
      isRootInPlaybackRange(root) &&
      window.getComputedStyle(video).display !== 'none' &&
      hasActiveSource(video)
    );
  }

  function isRootInPlaybackRange(root) {
    var rect;
    var viewportHeight;
    var lead;

    if (root.hasAttribute('data-da-autoplay-video-eager')) {
      return true;
    }

    rect = root.getBoundingClientRect();
    viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    lead = viewportHeight * viewportLead;

    return rect.top < lead && rect.bottom > -lead;
  }

  function prepareVideo(video) {
    var preloadMode = video.getAttribute('data-da-autoplay-video-preload') || 'auto';

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.preload = preloadMode;

    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', preloadMode);
  }

  function scheduleRetry(video, reloadFirstFrame) {
    var state = getState(video);

    if (!isActiveVideo(video) || document.visibilityState === 'hidden' || state.retries >= maxRetries) {
      return;
    }

    window.clearTimeout(state.timer);
    state.retries += 1;

    state.timer = window.setTimeout(function () {
      if (reloadFirstFrame && video.currentTime === 0 && video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
        video.load();
      }

      playVideo(video);
    }, retryBaseDelay * state.retries);
  }

  function playVideo(video) {
    if (!isActiveVideo(video) || document.visibilityState === 'hidden' || !video.paused) {
      return;
    }

    hydrateVideoSources(video);
    prepareVideo(video);

    if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) {
      video.load();
    }

    var playAttempt = video.play();

    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(function () {
        scheduleRetry(video, false);
      });
    }
  }

  function recoverPosterLock(video) {
    if (video.currentTime === 0 && video.paused) {
      scheduleRetry(video, true);
    }
  }

  function schedulePosterChecks(video) {
    var state = getState(video);

    window.clearTimeout(state.posterTimerOne);
    window.clearTimeout(state.posterTimerTwo);

    state.posterTimerOne = window.setTimeout(function () {
      recoverPosterLock(video);
    }, 1500);

    state.posterTimerTwo = window.setTimeout(function () {
      recoverPosterLock(video);
    }, 3500);
  }

  function bindVideo(video) {
    var state = getState(video);

    if (state.bound) {
      return;
    }

    state.bound = true;

    video.addEventListener('playing', function () {
      state.retries = 0;
      window.clearTimeout(state.timer);
    });

    video.addEventListener('canplay', function () {
      playVideo(video);
    });

    video.addEventListener('loadeddata', function () {
      playVideo(video);
    });

    video.addEventListener('stalled', function () {
      scheduleRetry(video, true);
    });

    video.addEventListener('waiting', function () {
      scheduleRetry(video, false);
    });

    video.addEventListener('error', function () {
      scheduleRetry(video, true);
    });
  }

  function playVideos(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = Array.prototype.slice.call(scope.querySelectorAll(videoSelector));

    videos.forEach(function (video) {
      bindVideo(video);

      if (video.hasAttribute('data-da-autoplay-video-pause-when-hidden') && !isActiveVideo(video)) {
        video.pause();
      }

      playVideo(video);
      schedulePosterChecks(video);
    });

    startWatchdog();
  }

  function recoverCurrentVideos() {
    var videos = Array.prototype.slice.call(document.querySelectorAll(videoSelector));

    videos.forEach(function (video) {
      bindVideo(video);

      if (video.hasAttribute('data-da-autoplay-video-pause-when-hidden') && !isActiveVideo(video)) {
        video.pause();
      }

      playVideo(video);

      if (isActiveVideo(video)) {
        recoverPosterLock(video);
      }
    });
  }

  function startWatchdog() {
    if (watchdogTimer) {
      return;
    }

    watchdogStartedAt = Date.now();
    watchdogTimer = window.setInterval(function () {
      if (Date.now() - watchdogStartedAt > watchdogDuration) {
        window.clearInterval(watchdogTimer);
        watchdogTimer = 0;
        return;
      }

      if (document.visibilityState === 'visible') {
        recoverCurrentVideos();
      }
    }, watchdogInterval);
  }

  function playCurrentVideos() {
    playVideos(document);
  }

  function scheduleCurrentVideos() {
    window.clearTimeout(scrollTimer);

    scrollTimer = window.setTimeout(playCurrentVideos, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', playCurrentVideos);
  } else {
    playCurrentVideos();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      resumeAfterReturn();
    } else {
      playCurrentVideos();
    }
  });
  window.addEventListener('load', playCurrentVideos);
  window.addEventListener('resize', playCurrentVideos);
  window.addEventListener('orientationchange', playCurrentVideos);
  window.addEventListener('scroll', scheduleCurrentVideos, { passive: true });

  // Chrome may pause or freeze (decoder suspended, frame stuck while !paused)
  // background videos when the tab/window is hidden. Pause them ourselves on
  // hide, then on return force a clean resume and verify the frame advances.
  function pauseHiddenVideos() {
    var videos = Array.prototype.slice.call(document.querySelectorAll(videoSelector));

    videos.forEach(function (video) {
      if (!video.paused) {
        video.pause();
      }
    });
  }

  function checkFrozen(video) {
    var startTime = video.currentTime;

    window.setTimeout(function () {
      if (document.visibilityState !== 'visible' || !isActiveVideo(video)) {
        return;
      }

      if (
        !video.paused &&
        !video.seeking &&
        video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA &&
        video.currentTime === startTime
      ) {
        // Playing on paper but frame not moving: kick the pipeline.
        video.pause();
        try {
          video.currentTime = startTime;
        } catch (e) {}
      }

      playVideo(video);
    }, 1200);
  }

  function resumeAfterReturn() {
    var videos = Array.prototype.slice.call(document.querySelectorAll(videoSelector));

    videos.forEach(function (video) {
      var state = getState(video);

      state.retries = 0;
      window.clearTimeout(state.timer);
    });

    playCurrentVideos();

    videos.forEach(function (video) {
      if (isActiveVideo(video)) {
        checkFrozen(video);
      }
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      resumeAfterReturn();
    } else {
      pauseHiddenVideos();
    }
  });

  window.addEventListener('focus', function () {
    if (document.visibilityState === 'visible') {
      resumeAfterReturn();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    playVideos(event.target);
  });

  ['pointerdown', 'touchstart', 'keydown'].forEach(function (eventName) {
    document.addEventListener(eventName, playCurrentVideos, {
      once: true,
      passive: true
    });
  });
})();
